export default "__VITE_ASSET__DXHOK9tt__"